<template>
  <div>
    <v-layout row container justify-center>
      <v-dialog v-model="dialog" persistent max-width="1500">
        <v-card light class="pr-5 pl-5 pt-4 pb-4">
          <div v-if="loading" class="spacing-top">
            <v-flex offset-xs5 pa-5>
              <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
            </v-flex>
          </div>
          <div v-else>
            <span class="subheadline">Cuota</span>

            <v-layout row wrap class="item-group">
                <v-flex xs4>
                    <v-autocomplete v-model="moneda" label="Moneda" :error-messages="this.getRequiredErrors('moneda')"
                                :items="monedas" :readonly="$store.getters.isClubRole || !canEdit"></v-autocomplete>
                </v-flex>
              <v-flex xs4>
                <v-currency-field v-model="monto" label="Monto"
                :error-messages="this.getRequiredErrors('monto')" :readonly="$store.getters.isClubRole || !canEdit"></v-currency-field>

              </v-flex>
              <v-flex xs4>
                  <DatePickerForm v-model="fechaVencimiento" label="Fecha de Vencimiento" :readonly="$store.getters.isClubRole || !canEdit"
                  :error-messages="this.getRequiredErrors('fechaVencimiento')"></DatePickerForm>
              </v-flex>
            </v-layout>
            <v-switch v-model="clubPuedeBorrarAdjuntos"
              label="Club puede borrar adjuntos" color="primary lighten-2" :disabled="!canEdit" v-if="$store.getters.isSafRole"></v-switch>
            <span class="subheadline" v-if="puedeVerAdjuntos">Adjuntos</span>
            <v-layout row wrap class="item-group" v-if="puedeVerAdjuntos">
              <v-flex>
                <attachments-cuota :comprobantes="comprobantes" ref="attachments" :canEdit="canEdit && $store.getters.isClubRole"
                @adjuntosModificados="adjuntosModificados = true" :clubPuedeBorrarAdjuntos="clubPuedeBorrarAdjuntos"></attachments-cuota>
              </v-flex>
            </v-layout>
            <span class="subheadline" v-if="$store.getters.isSafRole && tieneAdjuntos">Pagos</span>
            <v-layout row wrap class="item-group" v-if="$store.getters.isSafRole && tieneAdjuntos">
              <v-flex>
                <pagos-de-cuota :cuotaId="cuotaId" :esMonedaExtranjera="esMonedaExtranjera" :canEdit="canEdit"
                  @updatedPagos="updatedCuota">
                </pagos-de-cuota>
              </v-flex>
            </v-layout>

            <ConfirmationDialog :function-yes="bindingFunction" ref="confirmLeave" title="Abandonar formulario"
                      text="Se perderán los cambios del formulario actual, ¿desea continuar?"></ConfirmationDialog>
            <v-card-actions>
              <v-btn color="primary" @click="closeDialog">Volver</v-btn>
              <v-spacer></v-spacer>
              <cambiar-estado-cuota v-if="canCorregir" @changeStatus="changeStatus" :estados="estados">
                <v-btn color="primary">Cambiar estado</v-btn>
              </cambiar-estado-cuota>
              <observaciones-cuota-popup :cuotaId="cuotaId" :canEdit="isEditing" v-if="isEditing" :tieneNotificaciones="tieneNotificaciones">
                Observaciones</observaciones-cuota-popup>
              <v-btn color="primary" @click="submit" v-if="canCreate">Crear</v-btn>
              <v-btn color="primary" @click="submit" v-else-if="canEdit && $store.getters.isSafRole">Guardar</v-btn>
              <v-btn color="primary" @click="uploadAllFiles" v-if="canEdit && $store.getters.isClubRole"
               :disabled="!modificoAdjuntos || saving">Guardar</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>

</template>

<script>

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import Constants from '../../../common/constants'
import DatePickerForm from '../../../common/ui/DatePickerForm'
import ObservacionesCuotaPopup from '../components/ObservacionesCuotaPopup'
import CambiarEstadoCuota from '../components/CambiarEstadoCuota'
import AttachmentsCuota from './AttachmentsCuota.vue'
import PagosDeCuota from './PagosDeCuota'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import axios from 'axios'

let S3Upload = require('../../../app/upload_s3')
const CancelToken = axios.CancelToken
let cancel

export default {
  mixins: [validationMixin, createEntityMixin, s3UploadMixin],

  validations: {
    moneda: { required },
    monto: { required },
    fechaVencimiento: { required }
  },

  components: {
    ConfirmationDialog,
    DatePickerForm,
    ObservacionesCuotaPopup,
    AttachmentsCuota,
    CambiarEstadoCuota,
    PagosDeCuota
  },

  data () {
    return {
      dialog: false,
      loading: false,
      cuotaId: null,
      loadingCondiciones: false,
      clubPuedeBorrarAdjuntos: true,
      estados: [],
      bindingFunction: null,
      monto: null,
      fechaVencimiento: null,
      moneda: null,
      canEdit: true,
      canCorregir: false,
      createPath: 'cuota/new',
      tieneNotificaciones: false,
      comprobantes: [],
      comprobantesAssets: [],
      monedas: [
        {
          text: 'ARS',
          value: Constants.ARS
        },
        {
          text: 'USD',
          value: Constants.USD
        },
        {
          text: 'EUR',
          value: Constants.EUR
        },
        {
          text: 'REAL',
          value: Constants.REAL
        }
      ]
    }
  },

  methods: {
    setData (data) {
      this.monto = data.importe
      this.moneda = data.moneda
      this.estadoDisplay = data.estadoDisplay
      this.fechaVencimiento = this.formatDateFromAPI(data.fechaVencimiento)
      this.tieneNotificaciones = data.tieneNotificaciones
      this.comprobantes = data.comprobantes
      this.canEdit = data.canEdit
      this.canCorregir = data.canCorregir
      this.clubPuedeBorrarAdjuntos = data.clubPuedeBorrarAdjuntos
      this.estados = data.estados
    },
    resetComponent () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    showDialog (cuotaId = null) {
      this.resetComponent()
      this.cuotaId = cuotaId
      if (cuotaId) {
        this.fetchData()
      }
      this.dialog = true
    },
    postSuccessfulSubmit () {
      this.saving = false
      this.s3uploads = []
      this.comprobantesAssets = []
      this.closeDialog()
      this.updatedCuota()
    },
    updatedCuota () {
      this.$emit('updatedCuota')
    },
    closeDialog () {
      this.dialog = false
    },
    getPayload () {
      const payload = { }
      if (this.$store.getters.isSafRole) {
        payload.fechaVencimiento = this.fechaVencimiento
        payload.deuda = this.deudaId
        payload.importe = this.monto
        payload.moneda = this.moneda
        payload.clubPuedeBorrarAdjuntos = this.clubPuedeBorrarAdjuntos
      } else {
        if (this.$refs.attachments.hasRemovedFiles()) {
          payload.deletedAdjuntos = this.$refs.attachments.getRemovedFiles()
        }

        if (this.$refs.attachments.hasAddedComprobante()) {
          payload.addedComprobante = this.comprobantesAssets
        }
      }
      return payload
    },
    uploadAllFiles (event) {
      this.saving = true
      let comprobantes = this.getComprobantes()
      let comprobanteFileInput = this.getComprobanteFileInput()
      this.preSubmit()
      if (this.isValidForm()) {
        this.saving = true
        let cancelToken = new CancelToken(function executor (c) {
          cancel = c
        })
        if (comprobantes.length > 0) {
          for (const i in comprobantes) {
            this.uploadFile(comprobantes[i], cancelToken, comprobanteFileInput, this.comprobantesAssets)
          }
        } else {
          this.submit()
        }
      }
    },
    uploadFile (currentFile, cancelToken, fileInput, assetList) {
      let currentUpload = this.prepareUpload(currentFile, cancelToken, fileInput, assetList)
      currentUpload.signS3()
    },
    handleError (fileInput) {
      this.$store.commit('setCustomErrorMsg', 'Se produjo un error al realizar el upload, por favor reintente.')
      this.s3uploads = []
      this.comprobantesAssets = []
      fileInput.cleanProgress()
      this.saving = false
    },
    prepareUpload (currentFile, cancelToken, fileInput, assetList) {
      const options = {
        /* eslint-enable */
        onProgressChanged: (fileName, totalProgress) => {
          fileInput.updateProgressFor(fileName, totalProgress)
        },
        onUploadCompleted: (asset) => {
          assetList.push(asset)
          if (this.comprobantesAssets.length === this.s3uploads.length) {
            this.submit()
          }
        },
        onServerError: (error) => {
          if (error) {
            cancel()
            this.handleError(fileInput)
          }
        },
        onS3Error: (error) => {
          if (error) {
            this.handleError(fileInput)
          }
        }
      }
      let currentUpload = new S3Upload.S3Upload(currentFile, options, cancelToken)
      this.s3uploads.push(currentUpload)
      return currentUpload
    },
    isValidForm () {
      if (this.$store.isSafRole) {
        return !this.$v.$invalid
      }
      return true
    },
    getComprobantes () {
      return this.$refs.attachments.getAddedComprobante()
    },
    getComprobanteFileInput () {
      return this.$refs.attachments.$refs.fileComprobante
    },
    hasRemovedFiles () {
      if (this.$refs.attachments) {
        return this.$refs.attachments.hasRemovedFiles()
      }
      return false
    },
    hasAddedFiles () {
      if (this.$refs.attachments) {
        return this.$refs.attachments.hasAddedFiles()
      }
      return false
    },
    changeStatus (estado) {
      this.$emit('changeStatus', this.cuotaId, estado)
      this.closeDialog()
    }
  },

  computed: {
    deudaId () {
      return this.$route.params.id
    },
    isEditing () {
      return this.cuotaId != null
    },
    editPath () {
      return `cuota/${this.cuotaId}`
    },
    canCreate () {
      return !this.isEditing && this.$store.getters.isSafRole
    },
    modificoAdjuntos () {
      return true
    },
    tieneAdjuntos () {
      return this.comprobantes.length > 0
    },
    puedeVerAdjuntos () {
      return this.isEditing && (this.$store.getters.isClubRole || this.tieneAdjuntos)
    },
    esMonedaExtranjera () {
      return this.moneda !== Constants.ARS
    }
  }
}
</script>
<style scoped>
.item-group{
  border-style: solid;
  border-radius: 5px;
  background-color: rgb(223, 223, 223);
  border-color: rgb(185, 184, 184);
  border-spacing: 1em;
  padding-left: 1.5em;
  padding-right: 1.5em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  margin-bottom: 2em;
}
.subheadline {
  color: lightslategray;
  font-size: 1.6em;
  color: rgb(60, 145, 197);
  padding-top: 1.5em;
  margin-top: 2em;
}
</style>
